export function paginate<T>(array: T[], pageNumber: number, pageSize: number) {
  return array?.slice(pageNumber * pageSize, pageNumber * pageSize + pageSize) as T[];
}
